<template>
    <button v-if="hasPower(power)" class="c-button" :class="[{'border': hollow, 'z-dis': disabled}, `s-${color}`]"
		:style="{
			'min-width': compWidth,
			'height': compHeight,
			'border-color': background,
			'border-radius': compRadius,
			'font-size': compFontSize,
			'color': fontColor,
			'background': background
		}"
		:disabled="!!disabled" @click="$event => $emit('click', $event)"
	>
		<div class="flex-center">
			<i v-if="iconClass" class="tf" :class="[iconClass]"></i>
			<span><slot></slot></span>
		</div>
	</button>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			power: String,
			
			width: [Number, String],  // 自定义宽度
			
			height: [Number, String],  // 自定义高度
			
			color: {  // 按钮颜色（default: 系统辅色；sys：系统主色；）
				type: String,
				default: 'default'
			},
			
			hollow: Boolean,  // 是否为空心按钮
			
			radius: String,  //  圆角大小
			
			size: {  // 按钮尺寸（s：小号；m：中号；l：大号）
				type: String,
				default: 's'
			},
			
			fontSize: String,  // 字体大小
			
			fontColor: String,  // 字体颜色
			
			background: String,  //  按钮颜色
			
			icon: String,  // 按钮图标（add：添加）
			
			disabled: Boolean  // 禁用
		},
		
		computed: {
			...mapGetters({
				hasPower: 'power'
			}),
			
			compWidth() {
				if (this.width) {
					return this.width + 'px';
				}
				
				return {
					s: '4em',
					m: '110px'
				}[this.size];
			},
			
			compHeight() {
				if (this.height) {
					return this.height + 'px';
				}
				
				return {
					s: '28px',
					m: '36px'
				}[this.size];
			},
			
			compRadius() {
				if (this.radius) {
					return this.radius + 'px';
				}
				
				return {
					s: '2px',
					m: '0'
				}[this.size];
			},
			
			compFontSize() {
				if (this.fontSize) {
					return this.fontSize + 'px';
				}
				
				return {
					s: '12px',
					m: '14px'
				}[this.size];
			},
			
			iconClass() {
				return {
					'add': 'tf-plus',
					'upload': 'tf-upload'
				}[this.icon];
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme';
	
	.c-button {
		box-sizing: border-box;
		position: relative;
		border: 1px solid #fff;
		padding: 0 1em;
		white-space: nowrap;
		color: #fff;
		theme-border(lesser);
		theme-background(lesser);
		
		&:hover {
			theme-border(lesserHover);
			theme-background(lesserHover);
		}
		
		&.s-sys {
			theme-border(main);
			theme-background(main);
			
			&:hover {
				theme-border(mainHover);
				theme-background(mainHover);
			}
		}
		
		&.border,
		&.border:hover {
			color: #000;
			background: #fff !important;
		}
		
		&:not(.border),
		&:not(.border):hover {
			color: #fff !important;
		}
		
		&.z-dis {
			border: none !important;
			color: #999 !important;
			background: #eee !important;
			cursor: not-allowed !important;
		}
		
		.tf {
			margin-right: 5px;
			font-size: 15px;
		}
		
		span {
			display: inline-block;
			vertical-align: 1px;
		}
	}
	
	colorList = ({
		name: 'black',
		normal: #333,
		hover: #000
	} {
		name: 'gray',
		normal: #ccc,
		hover: #000,
		font: #000
	} {
		name: 'red',
		normal: #f55,
		hover: #f33
	});
	
	.c-button
		for item in colorList
			&.s-{item.name}
				color: item.normal;
				color: item.font;
				border-color: item.normal;
				background: item.normal;
				
			&.s-{item.name}:hover
				color: item.hover;
				border-color: item.hover;
				background: item.hover;
</style>
